import React from "react";
import { Navigate } from "react-router-dom";
import { useConfigStatus } from "@/context/ConfigContext";
import { usePerformanceEnabled } from "@/lib/uiMode";
import { RECOGNITION } from "@/constants/testIds";

/**
 * Guarda da página "A minha evolução".
 *
 * A página só existe com `performance_enabled` ligada, para todos os perfis —
 * em modo shadow ninguém vê o próprio score, nem por URL directo. `ranking` e
 * `recognition` não entram aqui: governam blocos DENTRO da página, não o
 * acesso a ela. Admin e gestor analisam a adoção em `Equipa → Adoção`, que é
 * uma página distinta e não depende de flag nenhuma.
 *
 * Esconder a rota não substitui a validação no servidor: `/api/recognition/me`
 * devolve 403 ao operador enquanto a flag estiver desligada. Isto é só para
 * não mostrar um ecrã de erro a quem segue um link antigo.
 *
 * Enquanto a config não chegou não se decide: redireccionar aí mandaria
 * embora quem tem direito à página só porque o `GET /config` ia a caminho.
 */
export default function RecognitionRoute({ children }) {
  const enabled = usePerformanceEnabled();
  const configStatus = useConfigStatus();

  if (configStatus === "loading") {
    return (
      <div
        data-testid={RECOGNITION.routeLoading}
        className="min-h-screen flex items-center justify-center bg-surface-bg text-ink-secondary text-sm"
      >
        A carregar…
      </div>
    );
  }

  if (!enabled) return <Navigate to="/" replace />;

  return children;
}
